module.exports = __webpack_public_path__ + "img/about-volleyball-fox.0fad0c82.png";